import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e5661fa8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "record-detail-box" }
const _hoisted_2 = { class: "record-detail-button-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_form_item = _resolveComponent("ui-form-item")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_ui_form = _resolveComponent("ui-form")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ui_form, {
      "label-position": "right",
      "label-width": "150px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ui_form_item, { label: "提交人" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.modelValue.name || '-'), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_ui_form_item, { label: "联系手机" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.mobileText), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_ui_form_item, { label: "份数" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.modelValue.num || 0) + " 份", 1)
          ]),
          _: 1
        }),
        _createVNode(_component_ui_form_item, { label: "状态" }, {
          default: _withCtx(() => [
            _createElementVNode("span", {
              class: _normalizeClass(_ctx.getSignStatusClass(_ctx.modelValue.status))
            }, _toDisplayString(_ctx.getSignStatusText(_ctx.modelValue.status)), 3)
          ]),
          _: 1
        }),
        _createVNode(_component_ui_form_item, { label: "支付金额" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.payText), 1)
          ]),
          _: 1
        }),
        (_ctx.modelValue.orderNumber)
          ? (_openBlock(), _createBlock(_component_ui_form_item, {
              key: 0,
              label: "订单号"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.modelValue.orderNumber), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.modelValue.payTime)
          ? (_openBlock(), _createBlock(_component_ui_form_item, {
              key: 1,
              label: "支付时间"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$format(_ctx.modelValue.payTime)), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_ui_form_item, { label: "报名时间" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$format(_ctx.modelValue.createTime)), 1)
          ]),
          _: 1
        }),
        (_ctx.modelValue.checkTime)
          ? (_openBlock(), _createBlock(_component_ui_form_item, {
              key: 2,
              label: "审核时间"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$format(_ctx.modelValue.checkTime)), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.modelValue.checkRemark)
          ? (_openBlock(), _createBlock(_component_ui_form_item, {
              key: 3,
              label: "审核备注"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.modelValue.checkRemark), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_divider),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (item) => {
          return (_openBlock(), _createBlock(_component_ui_form_item, {
            key: item.id,
            label: item.name
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.formatAnswer(item, _ctx.answerMap[`${item.id}`])), 1)
            ]),
            _: 2
          }, 1032, ["label"]))
        }), 128))
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_button, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('reject')))
      }, {
        default: _withCtx(() => [
          _createTextVNode("关闭")
        ]),
        _: 1
      })
    ])
  ]))
}